import { ACTION_LIST_TYPES_CONTRACTS } from "./types";

import config from "./config/shared_api";
import PathUri from '@/utils/path_uri';

import axios from '@/plugins/http/axios.js';

const _pathUri = new PathUri(config.port, config.context);

export const SHARED_MODULE = {
    namespaced: true,

    actions: {
        [ACTION_LIST_TYPES_CONTRACTS]: () => {

            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: `${config.baseUrl}${_pathUri.generateUri()}/tipocontrato/`,
                })
                    .then(resp => resolve(resp.data))
                    .catch(err => reject(err))
            })
        }
    },
};